/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IPais from 'Infotrack@Modelos/administracion/pais/entidades/pais';
import React from 'react';
import PaisCM from '../controladorModelo/paisCM';
import { acciones, IEstadoPais } from '../reductorPais';
import PaisVista from '../vista/tablaPaisVista';

const paisCM = new PaisCM();

const TablePaisCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [paiss, setPaiss] = React.useState<IPais[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoPais>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarPais();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarPais = () => {
        manejadorIndicadorCargaGlobal(true);
        paisCM.consultarPais().then((paiss) => {
            setPaiss(paiss);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadPais?: IPais) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadPais, tipoFormulario } });
    };

    const confirmarEliminacion = (pais: IPais) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarPais(pais),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarPais = (pais: IPais) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        paisCM.eliminarPais(pais).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <PaisVista
            paiss={paiss}
            cargarPais={cargarPais}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TablePaisCV;
